export default "__VITE_ASSET__BeYh3ciU__ 1200w";